/* eslint-disable jsx-a11y/anchor-is-valid */
import style from "./style.module.scss";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { Icon } from "@jmc/solid-design-system/src/components/atoms/Icon/Icon";
import { mdiAlertCircleOutline } from "@mdi/js";
import classnames from "classnames";

import React from "react";

interface PropTypes {
    warning?: string | JSX.Element | JSX.Element[];
    cookieMessage?: string | JSX.Element | JSX.Element[];
    children?: JSX.Element | JSX.Element[];
    variant?: "banner" | "card" | "small";
    textSpacing?: boolean;
}

/**
 * Warning Message
 */
export const WarningMessage = ({
    warning,
    cookieMessage,
    children,
    variant = "banner",
    textSpacing = false,
}: PropTypes): JSX.Element => {
    return (
        <div className={classnames(style.container, style[variant], textSpacing ? style.section : null)}>
            <div className={classnames(style.content, textSpacing ? style.block : null)}>
                {variant !== "small" ? (
                    <section className={classnames(style.wrapper, textSpacing ? style.spacing : null)}>
                        <section className={style.iconContainer}>
                            <Icon icon={mdiAlertCircleOutline} />
                        </section>
                        <div className={style.text}>
                            <Typography color="inherit" size="inherit" lineHeight="l" className={style.message}>
                                {warning}
                            </Typography>
                            {children ? (
                                // Custom cookie toggle button overrides default link
                                children
                            ) : (
                                <Typography size="s" lineHeight="l">
                                    <a
                                        href="#"
                                        onClick={(e: any) => {
                                            e.preventDefault();
                                            (window as any)?.OneTrust?.ToggleInfoDisplay();
                                        }}
                                    >
                                        {cookieMessage}
                                    </a>
                                </Typography>
                            )}
                        </div>
                    </section>
                ) : children ? (
                    children
                ) : (
                    <Typography size="s" lineHeight="l" className={style.button}>
                        <a
                            href="#"
                            onClick={(e: any) => {
                                e.preventDefault();
                                (window as any)?.OneTrust?.ToggleInfoDisplay();
                            }}
                        >
                            {cookieMessage}
                        </a>
                    </Typography>
                )}
            </div>
        </div>
    );
};
